exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-4994f8c1] {\n  font-weight: bold;\n}\n.section-box[data-v-4994f8c1] {\n  padding-left: 1em;\n  text-indent: -1em;\n}\n.indent[data-v-4994f8c1] {\n  padding-left: 1em;\n}\n", ""]);
